


















































































import Vue from "vue"
import { cutOffTimeService, ICutOffTimeService } from "@/model/service/cut-off-time/cut-off-time-service"
import { CutOffTime } from "@/model/entity/cut-off-time/cut-off-time"
import Datatable, { IDatatable, DatatableOptions } from "@/components/datatable/Datatable.vue"
import CutOffTimeEditor from "@/components/cut-off-time/CutOffTimeEditor.vue"

export interface ICutOffTimePageData {
  cutOffTimeService: ICutOffTimeService
  fields: any
  editorVisible: boolean
  formsValid: boolean
  deleteDialog: boolean
  selectedCutOffTimeId: number
  cutOffTime: CutOffTime
  options: DatatableOptions
}

export default Vue.extend({
  components: {
    Datatable,
    CutOffTimeEditor
  },
  data(): ICutOffTimePageData {
    return {
      options: {
        operations: {}
      },
      cutOffTimeService: cutOffTimeService,
      fields: CutOffTime.getFieldDescriptionList(),
      editorVisible: false,
      formsValid: false,
      deleteDialog: false,
      selectedCutOffTimeId: 0,
      cutOffTime: new CutOffTime()
    }
  },

  methods: {
    addCutOffTime() {
      this.cutOffTime = new CutOffTime()
      this.editorVisible = true
    },
    openEditDialog(id: number) {
      cutOffTimeService.findCutOffTimeById(id).then(response => {
        this.cutOffTime = response.data
        this.editorVisible = true
      })
    },
    saveCutOffTime() {
      const action = this.cutOffTime.id
        ? cutOffTimeService.updateCutOffTime(this.cutOffTime)
        : cutOffTimeService.saveCutOffTime(this.cutOffTime)
      action.then(() => {
        this.editorVisible = false
        const dataTable = this.$refs.datatable as IDatatable
        dataTable.refreshData()
      })
    },
    validateForm(isValid: boolean) {
      this.formsValid = isValid
    },
    modelChanged(value: CutOffTime) {
      this.cutOffTime = value
    },
    deleteCutOffTime(id: number) {
      cutOffTimeService.deleteCutOffTime(id).then(() => {
        const dataTable = this.$refs.datatable as IDatatable
        dataTable.refreshData()
        this.deleteDialog = false
        this.$message({
          message: this.$t("cut_off_time.deleted") as string,
          type: "success"
        })
      })
    },
    openDeleteDialog(selectedCutOffTimeId: number) {
      this.deleteDialog = true
      this.selectedCutOffTimeId = selectedCutOffTimeId
    }
  }
})
